<div class="flex flex-col gap-6 p-3">
  <div
    #dropZone
    class="grid place-items-center rounded-lg border-2 border-dashed border-french-blue-500 p-5"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input
      #fileInput
      type="file"
      (change)="onFileSelect($event)"
      hidden
      [multiple]="multiple"
      [accept]="supportedFileTypesString"
    />

    <div class="grid place-items-center gap-4">
      <div class="grid place-items-center gap-2">
        <div class="rounded-xl bg-french-blue-50/45 p-3">
          <svg-icon
            class="text-french-blue-500"
            src="/assets/icons/general/upload.svg"
          />
        </div>
        <p class="text-center text-base font-medium text-slate-800">
          {{
            multiple
              ? "Drag and drop your files here."
              : "Drag and drop a file here."
          }}
        </p>
        <p class="text-sm text-slate-500">
          <span
            class="block max-w-80 truncate"
            [pTooltip]="supportedFileTypesString"
          >
            Supported files: {{ supportedFileTypesString }}
          </span>
        </p>
      </div>
      <p class="text-slate-500">or</p>
      <p-button
        label="Choose a file"
        (click)="fileInput.click()"
        [disabled]="isDisabled"
      />
    </div>
  </div>

  <div class="flex flex-col gap-3">
    @if (files.length) {
      <p class="text-sm font-semibold text-slate-800">Uploading</p>
    }

    <div class="max-h-80 overflow-auto">
      @for (file of files; track file; let index = $index) {
        <div>
          <div class="flex items-center gap-2 p-1">
            <svg-icon
              class="text-french-blue-500"
              src="/assets/icons/general/document-text.svg"
            />
            <p
              class="shrink truncate text-base font-medium"
              [pTooltip]="file.name + '.' + file.type"
            >
              {{ file.name }}
            </p>
            <span class="whitespace-nowrap"> .{{ file.type }} </span>
            <span class="whitespace-nowrap font-normal text-slate-500">
              {{ file.size }}
            </span>
            <div class="ml-auto shrink-0 basis-16">
              @if (file.progress < 100) {
                <div
                  class="relative w-full rounded-full bg-french-blue-100 p-1"
                >
                  <div
                    class="absolute inset-y-0 left-0 rounded-full bg-french-blue-500"
                    [style.width.%]="file.progress"
                  ></div>
                </div>
              }
              @if (file.progress === 100) {
                <div class="flex items-center gap-3">
                  <svg-icon
                    class="ml-auto text-green-600"
                    src="/assets/icons/general/circle-check.svg"
                  />
                </div>
              }
            </div>
            <p-button
              size="small"
              severity="contrast"
              variant="text"
              pTooltip="Remove"
              tooltipPosition="left"
              (click)="onRemove(index)"
            >
              <ng-template #icon>
                <svg-icon src="/assets/icons/general/remove.svg" />
              </ng-template>
            </p-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
